// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-actions[data-v-52f16ee2]{margin-top:1.875rem}.form-actions p[data-v-52f16ee2]{margin-top:.625rem}.form-actions .btn[data-v-52f16ee2]{margin-right:.625rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
